module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei2.svg";